import Vue from 'vue'
import Vuex from  'vuex'
import createPersistedState from "vuex-persistedstate"
import frame from './frame'
import common from './modules/common'
import user from './modules/user'
import menu from './modules/menu'
import dept from './modules/dept'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    frame,
    common,
    user,
    menu,
    dept
  },
  plugins: [createPersistedState({
    // storage: window.sessionStorage,      // 仅在当前页签中存储
    storage: window.localStorage,        // 在当前浏览器中存储
    reducer(val) {
      return {
        frame: val.frame,
        user: val.user,
        menu: val.menu,
        dept: val.dept
      }
    }
  })]
})



// WEBPACK FOOTER //
// ./src/store/index.js